import { If, onMount, reactive } from 'cdui-js';
import { UploadImage } from '../../../../components/Upload';
import { applyUserBankView, changeFile, lastProcess, pState, setFormValidateFunc } from '../../store';
import { loadMarketBanks, resolveOpenAccountBankDisplay } from './AddBankAccount';
import { commonState, waitForEncryptKey } from '../../../../../../stores/common';
import { aesDecryptHexByPass } from '../../../../../../lib/crypto';
import { UploadProof } from '../../UploadProof';
import { LastNextBtns } from '../../components/LastNextBtns';
import { trackAccountOpenSubmit } from '../../../../../../analytics';
import { fetchAllInfos, submitApply } from '../../../../../../api/open-account';
import { FieldReEditHint } from '../../components/FieldReEditHint';
import { showToast } from '../../../../components/Toast';
import i18n from '../../../../../../i18n';
import { replaceTemplate } from '@china-difi/lib/template';
import { completeKycSubmitStep } from '../../kycAnalytics';
import { OPEN_ACCOUNT_TRANSFER, formatTransferAmount } from '../../../../utils/open-account-transfer';
import { isOpenProgressReEdit } from '../../reEditMode';

export const BankInfoConfirm = (props) => {
  const C = i18n.OpenProgress.Transfer.Confirm;
  const state = reactive({ companyBankAccount: '' });

  const decryptCompanyBankAccount = () => {
    const encrypted = pState.taxInfoForm.bankAccount;
    if (!encrypted || !commonState.encryptKey) return '';
    try {
      return aesDecryptHexByPass(encrypted, commonState.encryptKey) || '';
    } catch {
      return '';
    }
  };

  const getBankImg = () => {
    const file = pState.attachmentList.find((i) => i.attachType === 'transfer_prove');

    return file?.fileUrl;
  };

  const validateProof = async () => {
    if (!getBankImg()) {
      showToast(C.ToastProofRequired);
      return false;
    }
    return true;
  };

  onMount(() => {
    setFormValidateFunc({
      callback: validateProof,
    });

    state.companyBankAccount = decryptCompanyBankAccount();
    if (!state.companyBankAccount && pState.taxInfoForm.bankAccount) {
      void waitForEncryptKey().then((key) => {
        if (!key) return;
        state.companyBankAccount = decryptCompanyBankAccount();
      });
    }

    void loadMarketBanks().catch(() => {});
    // 上一步刚绑定，进页再拉一次，展示 userBankBindList 第一项的银行名 / 脱敏账号
    void fetchAllInfos('NEW_APPLY')
      .then((data) => {
        applyUserBankView(data?.userBankBindList);
      })
      .catch(() => {});
  });

  return (
    <div class="padding-x-L margin-y-XXL">
      <div class="bg-c-D flex-column gap-12px padding-L round margin-b-XS bank-info-confirm-account-row">
        <div class="flex justify-space-between align-start gap-12px">
          <div class="flex-shrink-0">{i18n.OpenProgress.Transfer.Bank.BankName}</div>
          <div class="text-right color-D confirm-infos-value bank-info-confirm-account-row__value">
            {resolveOpenAccountBankDisplay(pState.userBankView)}
          </div>
        </div>
        <div class="flex justify-space-between align-start gap-12px">
          <div class="flex-shrink-0">{i18n.OpenProgress.Transfer.Bank.AccountNo}</div>
          <div class="text-right color-D confirm-infos-value bank-info-confirm-account-row__value">
            {pState.userBankView.bankAccountNo}
          </div>
        </div>
      </div>

      <div>
        {i18n.OpenProgress.Transfer.Confirm.WrongAccountHint}
        <span
          class="link-color"
          onclick={() => {
            lastProcess();
          }}
        >
          {i18n.OpenProgress.Transfer.Confirm.ClickToEdit}
        </span>
      </div>

      <div class="font-s color-D margin-y-L font-bold">{replaceTemplate(i18n.OpenProgress.Transfer.Confirm.TransferTo, { company: i18n.OpenProgress.Common.DefaultCompanyHk })}</div>

      <div class="bg-c-D round flex flex-column align-center padding-L color-D margin-b-L">
        <div class="flex align-center gap-8px">
          <svg width="24" height="24" viewBox="0 0 24 24" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_278_1037)">
              <path
                d="M23.9566 11.5261H19.6188L19.8111 12.0217H23.9682V11.5261H23.9566ZM4.20117 16.8661H10.8358L7.45007 8.66333L4.20117 16.8661ZM18.8473 9.70903H23.7466L23.6989 9.49071L23.6522 9.28393L23.6367 9.21367H18.626L18.8475 9.70929L18.8473 9.70903ZM11.001 16.8661H17.6364L14.2501 8.66333L11.001 16.8661Z"
                fill="#A61F23"
              />
              <path
                d="M21.8206 16.7013L19.2325 20.4722H5.0826L2.30169 17.0044L8.41303 1.23029L11.8821 9.48934L15.1863 1.14848L18.351 8.55336H23.4577C21.97 3.63064 17.4002 0.0467529 11.9932 0.0467529C5.38004 0.0467529 0.0185547 5.40824 0.0185547 12.0216C0.0185547 18.635 5.37976 23.9962 11.9932 23.9962C17.1658 23.9962 21.5717 20.7167 23.2471 16.1234H21.5731L21.8206 16.7013H21.8206Z"
                fill="#A61F23"
              />
              <path
                d="M20.0862 12.6822L20.3069 13.1784H23.9123L23.9673 12.6822H20.0862ZM20.8015 14.3346H23.7468L23.7769 14.1536L23.8289 13.8398H20.5821L20.802 14.3346L20.8015 14.3346ZM19.3155 10.8652H23.9123L23.9077 10.8371L23.8809 10.5766L23.8584 10.3699H19.1221L19.3152 10.8652H19.3155ZM21.0775 14.9941L21.2974 15.4629H23.473L23.6111 14.9941H21.0772H21.0775Z"
                fill="#A61F23"
              />
            </g>
            <defs>
              <clipPath id="clip0_278_1037">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <div>{pState.taxInfoForm.bankBranchName}</div>
        </div>

        <div class="font-bold font-s-L margin-t-XXS">{state.companyBankAccount}</div>
      </div>

      <div class="flex">
        <div
          class="color-D bg-c-XD flex align-center justify-center margin-r-S"
          style={{ 'border-radius': '50%', width: '20px', height: '20px', 'margin-top': '2px' }}
        >
          1
        </div>
        <div class="flex-auto">
          <div class="color-D font-s font-bold">{i18n.OpenProgress.Transfer.Confirm.Step1Title}</div>

          <div
            style={{ border: '1px solid var(--check-border)' }}
            class="round flex justify-space-between padding-L color-D margin-y"
          >
            <div class="flex flex-column gap-12px">
              <div class="flex align-center">
                <div
                  class="border border-c border-bold margin-r-XXS"
                  style={{ width: '4px', height: '4px', 'border-radius': '50%' }}
                ></div>
                {i18n.OpenProgress.Transfer.Confirm.MinAmountBefore}<span class="color-error margin-x-XXS">{formatTransferAmount(OPEN_ACCOUNT_TRANSFER.minHkd)}</span>{i18n.OpenProgress.Transfer.Confirm.MinAmountAfter}
              </div>

              <div class="flex align-center">
                <div
                  class="border border-c border-bold margin-r-XXS"
                  style={{ width: '4px', height: '4px', 'border-radius': '50%' }}
                ></div>
                {i18n.OpenProgress.Transfer.Confirm.HkdOnly}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex margin-t-XL">
        <div
          class="color-D bg-c-XD flex align-center justify-center margin-r-S"
          style={{ 'border-radius': '50%', width: '20px', height: '20px', 'margin-top': '2px' }}
        >
          2
        </div>
        <div class="flex-auto" style={{ 'min-width': 0 }}>
          <div class="color-D font-s font-bold margin-b-S">{replaceTemplate(i18n.OpenProgress.Transfer.Confirm.Step2Title, { name: i18n.OpenProgress.Common.PlaceholderBrand })}</div>

          <UploadProof
            useFor="transfer_prove"
            busId={pState.id}
            img={getBankImg()}
            change={({ url }) => {
              changeFile('transfer_prove', url);
            }}
          />
          <FieldReEditHint field="transfer_prove" />

          {/* <div class="relative">
            <UploadImage
              style={{ position: 'absolute', top: 0, left: 0, zIndex: 2, width: '100%', height: '100%' }}
              useFor="transfer_prove"
              busId={pState.id}
            />
            {getBankImg() ? (
              <img style={{ width: '54px', height: '54px' }} src={imageBase + getBankImg()} />
            ) : (
              <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                  x="0.5"
                  y="0.5"
                  width="53"
                  height="53"
                  rx="11.5"
                  style={{ stroke: 'var(--border-1)' }}
                  stroke-linecap="round"
                  stroke-dasharray="3 6"
                />
                <path
                  d="M27 22V32"
                  style={{ stroke: 'var(--text-1)' }}
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M22 27H32"
                  style={{ stroke: 'var(--text-1)' }}
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            )}
          </div> */}
        </div>
      </div>

      <If when={!isOpenProgressReEdit(props)}>
        <LastNextBtns
          last={() => {
            lastProcess();
          }}
          next={async () => {
            if (!(await validateProof())) return;

            try {
              // X-No-Toast：失败改由单按钮弹窗提示，避免与拦截器 Toast 叠两层
              await submitApply(
                { id: pState.id, progress: 20 },
                { headers: { 'X-No-Toast': '1' } },
              );
              trackAccountOpenSubmit();
              completeKycSubmitStep(true);
              if (pState.auditInfo) pState.auditInfo.status = 'SUBMITTED';
            } catch (e) {
              trackAccountOpenSubmit();
              completeKycSubmitStep(false);
              const { showSubmitFailThenFinish } = await import('../../showSubmitSuccessModal');
              showSubmitFailThenFinish(e);
              return;
            }

            // 提交成功：不进 H5 Reviewing，直接回 App（H5 弹成功后再去下载页）
            const { showSubmitSuccessModal } = await import('../../showSubmitSuccessModal');
            showSubmitSuccessModal();
          }}
        />
      </If>
    </div>
  );
};
